import React, { Component } from 'react'

export class Header extends Component {

    
    render() {
        return (
            <div className="w3-card w3-top w3-blue w3-large" style={{zIndex: '4'}} >
                <button className=" w3-button w3-hide-large w3-hover-none w3-hover-text-light-grey" id='myMenu'><i className="fa fa-bars"></i>  Menu</button>
                <span className=" w3-padding w3-right">MI Smart Grids</span>
            </div> 
        )
    }
}

export default Header
